module.exports = __webpack_public_path__ + "img/light_online_notfollow.0cbf0953.png";